import { useState, useEffect } from 'react'
import { useMap } from 'react-leaflet'

export default function useMapZoom() {

    const map = useMap()

    const [mapProps, setMapProps] = useState([map.getZoom(), map.getCenter(),
    map.getBounds()])

    useEffect(() => {
        function handleResize() {

            setMapProps([map.getZoom(), map.getCenter(),
            map.getBounds()])

        }

        map.on('move', handleResize)
        return () => {

            map.off('move', handleResize)

        }
    }, [map])

    return mapProps
}
